import type { CardSize, CardTemplate } from "./types";

export const DOMAIN_COLORS: Record<string, string> = {
  "Executing":             "#5CB85C",
  "Strategic Thinking":    "#1E7A8C",
  "Relationship Building": "#155E6D",
  "Influencing":           "#F5A623",
};

export const DOMAIN_LABELS_AR: Record<string, string> = {
  "Executing":             "التنفيذ",
  "Strategic Thinking":    "التفكير الاستراتيجي",
  "Relationship Building": "بناء العلاقات",
  "Influencing":           "التأثير",
};

export const CARD_SIZES: Record<CardSize, { width: number; height: number; label: string }> = {
  instagram: { width: 1080, height: 1080, label: "1080×1080 (Instagram / WhatsApp)" },
  linkedin:  { width: 1200, height: 630,  label: "1200×630 (LinkedIn)" },
};

export const TEMPLATE_META: Record<CardTemplate, { label: string; desc: string }> = {
  bold:    { label: "Bold",    desc: "Maher gradient, glowing accents" },
  minimal: { label: "Minimal", desc: "Clean & light, no distractions" },
  classic: { label: "Classic", desc: "Corporate, structured teal" },
};

/** Factor to shrink full-resolution card into the preview viewport */
export const PREVIEW_SCALE = 0.38;

export const DEFAULT_PLATFORM_URL = "https://clifton.nex-ai-sa.com";
